// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteButton_wrapper__F1fdh","delete-button":"DeleteButton_delete-button__0TdUS","deleteButton":"DeleteButton_delete-button__0TdUS"};